import { Layout } from "antd";
import React from "react";
import DrawerList from "../DrawerList";

import { StyledContent1, StyledText } from "./styles";

const { Content } = Layout;

export const Newslistbar = ({ drawerData, showModal }) => {
  return (
    <Content
      style={{
        height: "100%",
        width: "100%",
        background: "white",
        display: "flex",
        flexDirection: "column",
        zIndex: 0,
      }}
    >
      <>
        <StyledContent1 style={{ overflowY: "auto" }}>
          <StyledText style={{ color: "red" }}>
            Note: For best results, please group related news together.
          </StyledText>
          <DrawerList drawerData={drawerData} showModal={showModal} />
        </StyledContent1>
      </>
    </Content>
  );
};
